import { render, staticRenderFns } from "./BillSummary.vue?vue&type=template&id=0ceb2bea&scoped=true&"
import script from "./BillSummary.vue?vue&type=script&lang=js&"
export * from "./BillSummary.vue?vue&type=script&lang=js&"
import style0 from "./BillSummary.vue?vue&type=style&index=0&id=0ceb2bea&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceb2bea",
  null
  
)

export default component.exports